import { render } from "./VbotsForGuest.vue?vue&type=template&id=1c2811f2&scoped=true"
import script from "./VbotsForGuest.vue?vue&type=script&lang=js"
export * from "./VbotsForGuest.vue?vue&type=script&lang=js"

import "./VbotsForGuest.vue?vue&type=style&index=0&id=1c2811f2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo.ETAGEN\\Documents\\Adam-Backend\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2811f2"]])

export default __exports__